import { endOfDay, startOfDay } from "date-fns";
import { DateFilterValue } from "@/types/reports";
import { isToday, isYesterday, format } from "date-fns";

export const formatDateToString = (timestamp: number | string): string => {
  const date = new Date(timestamp);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear().toString().substr(-2);
  return `${day} ${month}, ${year}`;
};

export const formatDate = (date: string | number | Date): string => {
  const messageDate = new Date(date);
  if (isToday(messageDate)) {
    return "Today";
  } else if (isYesterday(messageDate)) {
    return "Yesterday";
  } else {
    return format(messageDate, "d MMMM yyyy");
  }
};

export function convertToUTC(dateInput: Date | number | string) {
  let date;
  if (dateInput instanceof Date) {
    date = dateInput;
  } else if (typeof dateInput === "number") {
    date = new Date(dateInput);
  } else if (typeof dateInput === "string") {
    date = new Date(dateInput.includes("Z") || dateInput.includes("+") ? dateInput : `${dateInput}Z`);
  } else {
    date = new Date(dateInput);
  }
  return date.toISOString();
}

export const generateTimeArray = () => {
  const times = [];
  const formatTime = (hours: number, minutes: number) => {
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes}${period}`;
  };

  for (let hours = 0; hours < 24; hours++) {
    for (let minutes = 0; minutes < 60; minutes += 1) {
      const time = formatTime(hours, minutes);
      times.push(time);
    }
  }

  return times;
};

export function getMinEndDate(startDate?: DateFilterValue) {
  if (!startDate) return undefined;
  return endOfDay(new Date(startDate as string));
}

export function getMaxStartDate(endDate?: DateFilterValue) {
  if (!endDate) return undefined;
  return startOfDay(new Date(endDate as string));
}

export function getDateString(d: Date, isStartDate: boolean, isEndDate: boolean) {
  let date: Date;
  if (isStartDate) date = startOfDay(d);
  else if (isEndDate) date = endOfDay(d);
  else date = new Date();
  return date.toISOString();
}
